import axios, { AxiosError } from 'axios';
import { CommonRootState } from '../combineReducers';
import { IOrganizationUserGroupsAndRoles } from '../interfaces/organizationUserGroupsAndRoles';
import { sendError } from '../sendError';
import { ThunkAction } from 'redux-thunk';

export const fetchOrganizationUserGroupsAndRolesRequest = () =>
  ({
    type: 'FETCH_ORGANIZATION_USER_GROUPS_AND_ROLES_REQUEST'
  } as const);

export const fetchOrganizationUserGroupsAndRolesSuccess = (payload: IOrganizationUserGroupsAndRoles) =>
  ({
    type: 'FETCH_ORGANIZATION_USER_GROUPS_AND_ROLES_SUCCESS',
    payload
  } as const);

export const fetchOrganizationUserGroupsAndRolesFailure = (error: AxiosError) => {
  sendError(error);
  return {
    type: 'FETCH_ORGANIZATION_USER_GROUPS_AND_ROLES_FAILURE',
    error
  } as const;
};

const shouldFetchOrganizationUserGroupsAndRoles = (state: CommonRootState) => {
  const {
    organizationUserGroupsAndRoles: { isFetching, error, organizationUserGroupsAndRoles }
  } = state;

  return !isFetching && !error && !organizationUserGroupsAndRoles;
};

const fetchOrganizationUserGroupsAndRoles = (
  organizationId: string,
  userId: string
): ThunkAction<void, CommonRootState, null, Actions> => async dispatch => {
  try {
    dispatch(fetchOrganizationUserGroupsAndRolesRequest());

    const response = await axios.get<IOrganizationUserGroupsAndRoles>(
      `/api/v3.1/organizations(${organizationId})/users(${userId})/security`
    );

    dispatch(fetchOrganizationUserGroupsAndRolesSuccess(response.data));
  } catch (error) {
    dispatch(fetchOrganizationUserGroupsAndRolesFailure(error));
  }
};

export const fetchOrganizationUserGroupsAndRolesIfNeeded = (
  organizationId: string,
  userId: string
): ThunkAction<void, CommonRootState, null, Actions> => (dispatch, getState) => {
  if (shouldFetchOrganizationUserGroupsAndRoles(getState())) {
    dispatch(fetchOrganizationUserGroupsAndRoles(organizationId, userId));
  }
};

export type Actions =
  | ReturnType<typeof fetchOrganizationUserGroupsAndRolesRequest>
  | ReturnType<typeof fetchOrganizationUserGroupsAndRolesSuccess>
  | ReturnType<typeof fetchOrganizationUserGroupsAndRolesFailure>;
